<div class="d-flex" id="wrapper">
    <admin-sidebar></admin-sidebar>

    <div id="page-content-wrapper">

        <admin-navigation></admin-navigation>

        <div class="container-fluid">
            <div class="col-md-12 redirect-link mt-4 pl-0">
                <i class="fa fa-angle-left align-middle"></i>
                <a [routerLink]="['/admin/resources/audio-pods']" class="pl-2 pl-md-2 align-middle">Back to Listing</a>
            </div>
            <div class="d-flex align-items-center mt-5 mb-3">
                <h3 class="font-weight-bold page-title mr-auto">{{ resource?.title }}</h3>
                <div>
                    <button
                        type="submit"
                        class="btn btn-danger delete-button mr-2"
                        data-toggle="modal" 
                        data-target="#deleteResourceModal"
                    >
                        <i class="fa fa-trash"></i>
                    </button>
                    <button
                        type="submit"
                        class="btn btn-primary pull-right add-button"
                        form="ngForm"
                    >
                        Save
                    </button>
                </div>
            </div>

            <div class="resource-details-container pr-3 py-3" id="resource-details-container">
                <div class="card p-4 shadow-sm rounded-0 border-0">
                    <h3 class="d-inline-block font-weight-bold">Details</h3>
                    <form class="mt-2" [formGroup]="resourceForm" (ngSubmit)="onSubmit(resourceForm, $event)" id="ngForm">
                        <div class="form-group">
                            <div class="md-input w-75">
                                <input 
                                    type="text"
                                    required
                                    class="md-form-control"
                                    formControlName="title"
                                    [ngClass]="{'error': (!resourceForm.controls.title.pristine && resourceForm.controls.title.hasError('required')) || 
                                        resourceForm.controls.title.hasError('minlength')}"
                                >
                                <span class="highlight"></span>
                                <span class="bar"></span>
                                <label>Title</label>
                            </div>
                        </div>
                        <div class="form-group">
                            <div class="md-input w-50">
                                <select
                                    required
                                    class="md-form-control"
                                    formControlName="category"
                                >
                                    <option *ngFor="let cat of resourceCategories;" [value]="cat.value">{{ cat.text }}</option>
                                </select>
                                <span class="highlight"></span>
                                <span class="bar"></span>
                                <label>Category</label>
                            </div>
                        </div>
                        <div class="form-group">
                            <div class="md-input w-25">
                                <input
                                    type="number"
                                    class="md-form-control"
                                    required
                                    min="0"
                                    formControlName="points"
                                    [ngClass]="{'error': (!resourceForm.controls.points.pristine && resourceForm.controls.points.hasError('required'))}"
                                >
                                <span class="highlight"></span>
                                <span class="bar"></span>
                                <label>Points</label>
                            </div>
                        </div>
                        <div class="form-group">
                            <div class="md-input w-50">
                                <select
                                    required
                                    class="md-form-control"
                                    formControlName="fileType"
                                >
                                    <option *ngFor="let type of resourceFileTypes;" [value]="type.value">{{ type.text }}</option>
                                </select>
                                <span class="highlight"></span>
                                <span class="bar"></span>
                                <label>File Type</label>
                            </div>
                        </div>
                        <div class="form-group">
                            <div class="md-input w-75">
                                <input 
                                    type="text"
                                    required
                                    class="md-form-control"
                                    formControlName="fileTypeTitle"
                                    [ngClass]="{'error': (!resourceForm.controls.fileTypeTitle.pristine && resourceForm.controls.fileTypeTitle.hasError('required')) ||
                                        resourceForm.controls.fileTypeTitle.hasError('minlength')}"
                                >
                                <span class="highlight"></span>
                                <span class="bar"></span>
                                <label>File Type Title</label>
                            </div>
                        </div>
                        <div class="form-group ml-1">
                            <label class="font-weight-bold text-secondary">Is Free</label><br>
                            <label class="switch" for="checkbox">
                                <input type="checkbox" formControlName="isFree" id="checkbox">
                                <div class="slider round"></div>
                              </label>
                        </div>
                        <!-- Color -->
                        <div class="row">
                            <div class="col-md-4 mt-md-3 mt-3">
                            <label for="colorSelect" class="font-weight-bold text-secondary">Color</label>
                            <input
                                readonly
                                id="colorSelect"
                                class="form-control"
                                [(colorPicker)]="coverColor"
                                [style.background]="coverColor"
                                (colorPickerChange)="getCoverColor(coverColor)"
                                [cpAlphaChannel]="'disabled'"
                            />
                            </div>
                        </div>
                        <!-- End of Color -->
                    </form>
                </div>

                <div class="card p-4 shadow-sm rounded-0 border-0 mt-3">
                    <!-- Audio -->
                    <div id="image-container">
                        <div class="row">
                            <div class="col-md-12">
                                <h3 class="font-weight-bold page-title">Audio
                                <button
                                    type="button"
                                    class="btn btn-danger btn-sm pull-right"
                                    *ngIf="resource?.link_url !== '' && audioSourcePreview !== ''"
                                    (click)="deleteAudioUpload()"
                                >
                                    <i class="fa fa-trash"></i> Delete Upload
                                </button>
                                </h3>
                            </div>
                        </div>

                        <label
                        class="font-weight-bold text-center align-middle imageInputLabel"
                        for="audioFileInput"
                        >
                        {{ audioUploadLabel }}
                        </label>

                        <!-- Audio Error Message -->
                        <p class="text-danger" *ngIf="audioError">Audio File is required!</p>

                        <input
                            type="file"
                            class="ml-md-3 ml-3 file-input"
                            accept=".mp3, .wav, .ogg, audio/*"
                            (change)="onAudioFileInputChange($event)"
                            #audioFileInput
                            id="audioFileInput"
                        >
                        <!-- <img [src]="audioSourcePreview" *ngIf="audioSourcePreview" class="img-fluid mt-4 mt-md-4">
                        <img [src]="resource?.link_url" *ngIf="audioSourcePreview === ''" class="img-fluid mt-4 mt-md-4"> -->

                        <div plyr plyrType="audio" [plyrPlaysInline]="true" [plyrSources]="audioSources" id="audioPlayer" (plyrInit)="audioPlayer = $event"></div>
                    </div>
                    <!-- End of Audio -->

                    <!-- <div class="form-group">
                        <div plyr plyrType="audio" [plyrPlaysInline]="true" [plyrSources]="audioSources" id="audioPlayer" (plyrInit)="audioPlayer = $event"></div>
                    </div> -->
                </div>

                <div class="card p-4 shadow-sm rounded-0 border-0 mt-3">
                    <!-- Image -->
                    <div id="image-container">
                        <div class="row">
                            <div class="col-md-12">
                                <h3 class="font-weight-bold page-title">Image
                                <button
                                    type="button"
                                    class="btn btn-danger btn-sm pull-right"
                                    *ngIf="resource?.image_url !== '' && imageSourcePreview !== ''"
                                    (click)="deleteImageUpload()"
                                >
                                    <i class="fa fa-trash"></i> Delete Upload
                                </button>
                                </h3>
                            </div>
                        </div>

                        <label
                        class="font-weight-bold text-center align-middle imageInputLabel"
                        for="imageFileInput"
                        >
                        {{ imageUploadLabel }}
                        </label>

                        <!-- Image Error Message -->
                        <p class="text-danger" *ngIf="imageError">Image Cover is required!</p>

                        <input
                            type="file"
                            class="ml-md-3 ml-3 file-input"
                            accept=".jpg, .png, .jpeg, .gif|image/*"
                            (change)="onImageFileInputChange($event)"
                            #imageFileInput
                            id="imageFileInput"
                        >
                        <img [src]="imageSourcePreview" *ngIf="imageSourcePreview" class="img-fluid mt-4 mt-md-4">
                        <img [src]="resource?.image_url" *ngIf="imageSourcePreview == ''" class="img-fluid mt-4 mt-md-4">
                    </div>
                    <!-- End of Image -->
                </div>
            </div>

        </div>

        <!-- Modal Loader -->
        <modal-loader [modalText]="modalText"></modal-loader>

        <!-- Modal -->
        <div class="modal fade" id="deleteResourceModal" tabindex="-1" role="dialog" aria-labelledby="deleteResourceModalTitle" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-header">
                <h4 class="modal-title" id="cancelModalTitle">Delete Resource</h4>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
                </div>
                <div class="modal-body">
                    Are you sure you want to delete this resource?
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary btn-modal-cancel" data-dismiss="modal">No</button>
                    <button type="submit" class="btn btn-primary btn-modal-save" data-dismiss="modal" (click)="deleteResource(resource?.id)">Yes</button>
                </div>
            </div>
            </div>
        </div>

    </div>
</div>